import builder from '../builder';
import BicycleSports from '../../streamline-icons/light/bicycle-sports.svg';

export default builder('IconBicycleSportsLight', BicycleSports);
